import { CreateRenderFunction } from "@pdfking/reactivity/preact"
import { Icon } from "@pdfking/workflow/components/Icon"
import proxy from "@pdfking/workflow/utils/proxy"
import user from "../state/user"
import cx from "../utils/cx"

export const CartCounter = CreateRenderFunction({
  computed: proxy(user(), ["cart_counter"] as const),
  render() {
    return (
      <div
        class={cx("m-0 py-0", {
          "btn btn-sm btn-primary": (this.cart_counter as number) > 0,
        })}
      >
        <Icon name="SHOPPING_CART" />
        {(this.cart_counter as number) > 0 && (
          <span class="ms-1">{this.cart_counter as number}</span>
        )}
      </div>
    )
  },
})
